import Link from "next/link";
import router from "next/router";

const PageNumber = ({ page, currentPage }) => {
	const active = page === currentPage;

	return (
		<Link href={{ href: router.pathname, query: { page } }} shallow>
			<a className={`block bland mx-2 py-1 px-2 border-b ${active ? "border-b-primary" : "border-b-transparent"}`}>{page}</a>
		</Link>
	);
};

export default function PageNumbers({ page, totalPages }) {
	const limit = 10;
	const half = Math.round(limit / 2);

	const beforeCount = totalPages > limit && totalPages - page < 4 ? limit - (totalPages - page) : Math.min(4, page - 1);
	const afterCount = totalPages > limit && totalPages - page > 4 ? Math.max(4, limit - page) : Math.max(0, totalPages - page);

	const beginning = new Array(beforeCount).fill(0);
	const end = new Array(afterCount).fill(0);

	return (
		<>
			{page > half && <div className="mx-2 p-1 font-bold">...</div>}
			{beginning
				.map((_, index) => {
					const num = page - (index + 1);
					return <PageNumber key={num} currentPage={page} page={num} />;
				})
				.reverse()}
			<PageNumber key={page} currentPage={page} page={page} />
			{end.map((_, index) => {
				const num = page + index + 1;
				return <PageNumber key={num} currentPage={page} page={num} />;
			})}
			{page + afterCount < totalPages && <div className="mx-2 p-1 font-bold">...</div>}
		</>
	);
}
